module.exports = "/_next/static/images/mapa-default-5d51d1f5cb64930ddc90c243930e1384.png";